import type {
  VaultAiSuggestion,
  VaultNavItem,
  VaultSmartFolder,
  VaultSourceItem,
} from "@/types/vaultNav.types";

export const VAULT_NAV_ITEMS: VaultNavItem[] = [
  { id: "all", label: "All files", count: 16848 },
  { id: "recent", label: "Recent", count: 42 },
  { id: "starred", label: "Starred", count: 18 },
  { id: "shared", label: "Shared with me", count: 67 },
  { id: "trash", label: "Trash", count: 12 },
];

export const VAULT_SOURCES: VaultSourceItem[] = [
  {
    id: "eq",
    name: "Equal IQ Vault",
    connected: true,
    usedGb: 42.6,
    totalGb: 500,
    fileCount: 8412,
    tone: "#4d6af5",
  },
  {
    id: "dropbox",
    name: "Dropbox",
    connected: true,
    usedGb: 78.2,
    totalGb: 200,
    fileCount: 3146,
    tone: "#0061ff",
  },
  {
    id: "gdrive",
    name: "Google Drive",
    connected: true,
    usedGb: 124,
    totalGb: 300,
    fileCount: 5290,
    tone: "#1a73e8",
  },
  {
    id: "box",
    name: "Box",
    connected: false,
    tone: "#0061d5",
  },
  {
    id: "onedrive",
    name: "OneDrive",
    connected: false,
    tone: "#0078d4",
  },
];

export const VAULT_SMART_FOLDERS: VaultSmartFolder[] = [
  { id: "sf-contracts", label: "Active Contracts", count: 42, tone: "#22c55e" },
  { id: "sf-redlines", label: "Pending Redlines", count: 8, tone: "#f59e0b" },
  { id: "sf-tax", label: "Tax Documents 2026", count: 23, tone: "#8b5cf6" },
  { id: "sf-press", label: "Press & Media", count: 147, tone: "#ec4899" },
  { id: "sf-pitch", label: "Pitch Decks", count: 31, tone: "#22d3ee" },
];

export const VAULT_AI_SUGGESTIONS: VaultAiSuggestion[] = [
  {
    id: "s1",
    kind: "organize",
    title: "23 unfiled contracts",
    detail: "Sort into Clients/<name>/Contracts based on parties named in each doc.",
    action: "Apply",
    count: 23,
  },
  {
    id: "s2",
    kind: "duplicates",
    title: "8 duplicate files found",
    detail: "Same checksum across Dropbox + Drive. Keep newest, archive others.",
    action: "Review",
    count: 8,
  },
  {
    id: "s3",
    kind: "rename",
    title: "14 files with poor names",
    detail: "Untitled-1.pdf, Scan_2026.pdf… Rename based on content.",
    action: "Rename",
    count: 14,
  },
  {
    id: "s4",
    kind: "tag",
    title: "Auto-tag press hits",
    detail: "47 media files in Drive look like press from recent campaigns.",
    action: "Tag",
    count: 47,
  },
  {
    id: "s5",
    kind: "archive",
    title: "Move 312 stale files",
    detail: "Not opened in 18 months. Move to Archive (2024–2025).",
    action: "Archive",
    count: 312,
  },
];

export const VAULT_TOTAL_STORAGE = { usedGb: 245, totalGb: 1000 };
